"use strict";

function customAutoFocusDirective() {
  return {
    restrict: 'A',

    link: function(scope, element, attrs) {
      scope.$watch(function() {
        return scope.$eval(attrs.customAutofocus);
      }, function (newValue) {
        if (newValue === true) {
          setTimeout(function() {
            element[0].focus();
          }, 0);
        }
     });
    }
  };
}

angular.module('dokiv')
  .directive('customAutofocus', customAutoFocusDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/customAutoFocusDirective.js
// module id = 258
// module chunks = 0